module.exports = __webpack_public_path__ + "static/img/fz_dlb_what.2837e48.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_dlb_what.png
// module id = 7mHP
// module chunks = 0